import React, { useEffect, useMemo, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ThemeColor } from "../../component/theme/color";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetAllNotification,
  GetUnseenNotificationCount,
} from "../../Redux/action/NotificationAction";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CustomButton from "../../component/button/button";
import { AddPersonToNotificationModal } from "../../component/notificationModal/SendUserNotification";
import { MarkNotificationSeenAPI } from "../../Redux/service/notificationService";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { ContentState, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp"];
const EXCEL_EXTENSIONS = ["xls", "xlsx", "csv"];

const NotificationBody = ({ text }) => {
  const editorState = useMemo(() => {
    if (!text) return EditorState.createEmpty();
    const contentBlock = htmlToDraft(text);
    if (!contentBlock) return EditorState.createEmpty();
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
        contentBlock.entityMap
      )
    );
  }, [text]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
        "& .rdw-editor-main": {
          padding: 0,
        },
        "& .public-DraftStyleDefault-block": {
          margin: 0,
        },
        "& img": {
          maxWidth: "100%",
          height: "auto",
        },
      }}
    >
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        editorStyle={{
          color: "#344054",
          background: "transparent",
          minHeight: "40px",
          fontSize: "14px",
          lineHeight: "22px",
          wordBreak: "break-word",
        }}
        toolbarHidden
        readOnly
      />
    </Box>
  );
};

const DownloadLink = ({ href, children }) => (
  <Box
    component="a"
    href={href}
    download
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      mt: 0.75,
      maxWidth: "100%",
      fontSize: 13,
      color: "#2563eb",
      textDecoration: "none",
      wordBreak: "break-all",
      "&:hover": { textDecoration: "underline" },
    }}
  >
    <DownloadIcon sx={{ fontSize: 16, flexShrink: 0 }} />
    <Box component="span" sx={{ minWidth: 0 }}>
      {children}
    </Box>
  </Box>
);

const Attachment = ({ file }) => {
  const ext = file.split(".").pop().toLowerCase();
  const fileName = file.split("/").pop();

  const cardSx = {
    width: { xs: "100%", sm: 260 },
    maxWidth: "100%",
    p: 1.5,
    borderRadius: "12px",
    border: "1px solid #e6ecf5",
    backgroundColor: "#fbfcfe",
  };

  if (IMAGE_EXTENSIONS.includes(ext)) {
    return (
      <Box sx={cardSx}>
        <Box
          component="img"
          src={file}
          alt={fileName}
          sx={{
            width: "100%",
            height: { xs: 180, sm: 200 },
            objectFit: "cover",
            borderRadius: "8px",
            display: "block",
          }}
        />
        <DownloadLink href={file}>{fileName}</DownloadLink>
      </Box>
    );
  }

  if (ext === "pdf") {
    return (
      <Box sx={cardSx}>
        <Box
          component="embed"
          src={file}
          type="application/pdf"
          sx={{
            width: "100%",
            height: { xs: 180, sm: 200 },
            borderRadius: "8px",
            display: "block",
          }}
        />
        <DownloadLink href={file}>{fileName}</DownloadLink>
      </Box>
    );
  }

  return (
    <Box sx={{ ...cardSx, display: "flex", alignItems: "center", gap: 1.5 }}>
      {EXCEL_EXTENSIONS.includes(ext) ? (
        <Box
          component="img"
          src="/excel-icon.png"
          alt="excel"
          sx={{ width: 40, height: 40, flexShrink: 0 }}
        />
      ) : (
        <InsertDriveFileIcon sx={{ fontSize: 36, color: "#8DA0D9" }} />
      )}
      <Box sx={{ minWidth: 0 }}>
        <DownloadLink href={file}>{fileName}</DownloadLink>
      </Box>
    </Box>
  );
};

const AllNotificationpage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [AllNotification, setAllNotification] = useState([]);
  const [Chatlist, setChatlist] = useState([]);
  const [AddPersonNotification, setAddPersonNotification] = useState(false);
  const [selectedUser, setselectedUser] = useState();
  const [expanded, setExpanded] = useState(null);

  const isAgent = window.sessionStorage.getItem("user_role_type") === "agent";

  const NotificationlistState = useSelector(
    (state) => state.notification?.allNotification?.data?.data
  );

  const ChatlistState = useSelector(
    (state) => state.setting?.allchat?.data?.data
  );

  const handleClosePersonNotification = () =>
    setAddPersonNotification(!AddPersonNotification);

  useEffect(() => {
    setChatlist(ChatlistState);
  }, [ChatlistState]);

  useEffect(() => {
    setAllNotification(NotificationlistState);
  }, [NotificationlistState]);

  useEffect(() => {
    dispatch(GetAllNotification());
  }, []);

  const handleMarkNotificationSeen = async (id) => {
    await MarkNotificationSeenAPI(id)
      .then((res) => {
        if (res.status === 200) {
          dispatch(GetAllNotification());
          dispatch(GetUnseenNotificationCount());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleToggle = (data) => (event, isExpanded) => {
    setExpanded(isExpanded ? data._id : null);
    if (isExpanded && data?.isView === false) {
      handleMarkNotificationSeen(data._id);
    }
  };

  return (
    <>
      {/* Page header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "space-between",
          gap: { xs: 1.5, md: 2 },
          mb: { xs: 2, md: 3 },
        }}
      >
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          sx={{ fontSize: { xs: fontSize.h3.large, sm: fontSize.h2.small } }}
        >
          Notification List
        </Typography>

        {!isAgent && (
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1.5,
              width: { xs: "100%", md: "auto" },
              "& .MuiButton-root": {
                width: { xs: "100%", sm: "auto" },
              },
            }}
          >
            <CustomButton
              variant="contained"
              type="button"
              backgroundColor={ThemeColor.PURPLE}
              color={ThemeColor.WHITE}
              onClick={() => handleClosePersonNotification()}
            >
              Send Notification to User
            </CustomButton>
            <CustomButton
              variant="contained"
              type="button"
              backgroundColor={ThemeColor.PURPLE}
              color={ThemeColor.WHITE}
              onClick={() => navigate("/CAE/CreateNotification")}
            >
              Create Global Notification
            </CustomButton>
          </Box>
        )}
      </Box>

      {/* Notification list */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: ThemeColor.WHITE,
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(16, 24, 40, 0.06)",
          overflow: "hidden",
        }}
      >
        {AllNotification?.length > 0 ? (
          AllNotification.map((data, index) => {
            const unread = data?.isView === false;
            return (
              <Accordion
                key={data._id || index}
                disableGutters
                elevation={0}
                square
                expanded={expanded === data._id}
                onChange={handleToggle(data)}
                slotProps={{ transition: { unmountOnExit: true } }}
                sx={{
                  backgroundColor: unread ? "#EFF6FF" : ThemeColor.WHITE,
                  borderBottom: "1px solid #eef2f7",
                  transition: "background-color 0.2s ease",
                  "&:last-of-type": { borderBottom: "none" },
                  "&:before": { display: "none" },
                  "&:hover": {
                    backgroundColor: unread ? "#E4EEFD" : "#F8FAFD",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#667085" }} />}
                  sx={{
                    px: { xs: 1.5, sm: 2.5 },
                    py: { xs: 1, sm: 1.25 },
                    "& .MuiAccordionSummary-content": {
                      m: 0,
                      minWidth: 0,
                      alignItems: "center",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: { xs: 1.25, sm: 2 },
                      width: "100%",
                      minWidth: 0,
                    }}
                  >
                    <Box
                      sx={{
                        flexShrink: 0,
                        width: { xs: 36, sm: 42 },
                        height: { xs: 36, sm: 42 },
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: unread ? "#DBE8FE" : "#F1F5FB",
                        color: ThemeColor.BLUE,
                      }}
                    >
                      <NotificationsActiveIcon
                        sx={{ fontSize: { xs: 20, sm: 22 } }}
                      />
                    </Box>

                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          gap: { xs: 0.75, sm: 1 },
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: FontFamily.Poppins,
                            fontSize: { xs: 13.5, sm: fontSize.h3.medium },
                            fontWeight: unread
                              ? fontWeight.W600
                              : fontWeight.W500,
                            color: "#101828",
                            wordBreak: "break-word",
                          }}
                        >
                          {data.title}
                        </Typography>

                        <Chip
                          label={data.isPublic ? "Global" : "Personal"}
                          size="small"
                          sx={{
                            height: 20,
                            borderRadius: "6px",
                            fontSize: 11,
                            fontWeight: 600,
                            color: ThemeColor.WHITE,
                            backgroundColor: data.isPublic
                              ? ThemeColor.RED
                              : ThemeColor.BLUE,
                            "& .MuiChip-label": { px: 0.9 },
                          }}
                        />

                        {unread && (
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor: ThemeColor.RED,
                              flexShrink: 0,
                            }}
                          />
                        )}
                      </Box>

                      {data.attachmentUrl?.length > 0 && (
                        <Typography
                          sx={{ fontSize: 12, color: "#667085", mt: 0.25 }}
                        >
                          {data.attachmentUrl.length} attachment
                          {data.attachmentUrl.length > 1 ? "s" : ""}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    px: { xs: 1.5, sm: 2.5 },
                    pt: 0,
                    pb: { xs: 2, sm: 2.5 },
                    pl: { xs: 1.5, sm: 8 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1.5,
                      mb: data.attachmentUrl?.length > 0 ? 1.5 : 0,
                    }}
                  >
                    {data.attachmentUrl?.length > 0 &&
                      data.attachmentUrl.map((file, fileIndex) => (
                        <Attachment key={fileIndex} file={file} />
                      ))}
                  </Box>

                  <NotificationBody text={data.text} />
                </AccordionDetails>
              </Accordion>
            );
          })
        ) : (
          <Box
            sx={{
              py: { xs: 6, sm: 8 },
              px: 2,
              textAlign: "center",
              color: "#667085",
            }}
          >
            <NotificationsNoneIcon sx={{ fontSize: 44, opacity: 0.5 }} />
            <Typography
              sx={{
                mt: 1,
                fontFamily: FontFamily.Poppins,
                fontSize: fontSize.h3.small,
              }}
            >
              No notifications to show
            </Typography>
          </Box>
        )}
      </Box>

      <AddPersonToNotificationModal
        selectedUser={selectedUser}
        Participantlist={Chatlist?.participants?.map(
          ({ firstName, ...rest }) => ({
            title: firstName,
            ...rest,
          })
        )}
        AddPersonNotification={AddPersonNotification}
        handleClose={handleClosePersonNotification}
      />
    </>
  );
};

function AllNotification() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<AllNotificationpage />} />
    </div>
  );
}

export default AllNotification;
